import * as React from "react";
import styled from "styled-components";
import { darken } from "polished";
import { colors } from "../styles/variables";
import Button from "../Shared/Button";
import CloseIcon from "../../images/cancel.svg";
import { getImage } from "../utils/pathHelper";

const ModalView = styled.div`
  overflow: scroll;
  overscroll-behavior: none;
  z-index: 10;
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transform: translate3d(0,100vh,0);
  background-color: rgba(0,0,0,0.5);
  transition: all 0.2s ease-in-out;
  &.active {
    transform: translate3d(0,0,0);
  }
  & > .inner {
    background-color: ${colors.white};
    width: 800px;
    margin: auto;
    height: fit-content;

    @media (max-width: 768px) {
      margin: 60px var(--spacing-s);
    }

    .close-button-container {
      display: flex;
      justify-content: flex-end;
      padding: var(--spacing-s) var(--spacing-s) 0;
    }

    .close-button {
      border: none;
      background-color: transparent;
      cursor: pointer;
      width: 24px;
      height: 24px;
      color: var(--gray-700);
      &:hover {
        color: var(--gray-900);
      }
    }

    .footer {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 0.25rem 0.5rem;
      min-height: 60px;
    }
    .button {
      transition: all 0.2s ease-in-out;
      background-color: ${colors.red};
      padding: 0.5rem 1rem;
      border: none;
      border-radius: 4px;
      color: ${colors.white};
      text-decoration: none;
      min-width: 100px;
      display: inline-block;
      text-align: center;
      cursor: pointer;
      &:hover {
        background-color: ${darken(0.05, colors.red)};
        color: ${colors.white};
        text-decoration: none;
      }
    }
  }
`;

interface IModal {
	isShown: boolean;
	isShowFooter?: boolean;
	handleClose: () => void;
	className?: string;
}

const Modal: React.FC<IModal> = (props) => {
	const { isShown, handleClose, className } = props;
	function handleBackdropClick(event: React.MouseEvent) {
		event.preventDefault();
		event.stopPropagation();
		if (event.currentTarget === event.target) {
			// 最も外枠（Backdrop）をクリックした場合はモーダルを閉じる
			handleClose();
		}
	}
	return (
		<ModalView
			className={isShown ? "active" : null}
			onClick={handleBackdropClick}
		>
			<div className={`inner ${className || ""}`}>
				<div className="close-button-container">
					<img
						src={getImage(CloseIcon)}
						alt="close"
						width={16}
						height={16}
						onClick={handleClose}
						className="close-button"
					/>
				</div>
				{props.children}
				{props.isShowFooter && (
					<div className="footer">
						<div>
							<Button href="#" onClick={handleClose}>
								OK
							</Button>
						</div>
					</div>
				)}
			</div>
		</ModalView>
	);
};

export default Modal;
